import { useCallback, useMemo } from "react";
import {
  selectExclusiveCategories,
  selectMenuItem,
  selectSelectedExclusiveCategoryIds,
  setSelectedExclusiveCategoryIdsAction,
} from "@store/menuItem/menuItemReducer";
import { useAppDispatch, useAppSelector } from "@store/store";
import { Select } from "@ui-kit/Select/Select";
import { translate } from "@lib/translate";
import { ExpandIcon } from "@icons/ExpandIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
const ExclusiveCategoryFilter = () => {
  const exclusiveCategories = useAppSelector(selectExclusiveCategories);
  const menuItem = useAppSelector(selectMenuItem);
  const dispatch = useAppDispatch();
  const selectedCategoryIds = useAppSelector(
    selectSelectedExclusiveCategoryIds,
  );

  const menuItems = useMemo(() => {
    return exclusiveCategories.map((category) => ({
      label: category.name,
      value: String(category.id),
    }));
  }, [exclusiveCategories]);

  const handleToggleCategory = useCallback(
    (categoryIds: string[]) => {
      const categoryIdsNumber = categoryIds.map((x) => Number(x));
      dispatch(setSelectedExclusiveCategoryIdsAction(categoryIdsNumber));
    },
    [dispatch],
  );

  return (
    <>
      {exclusiveCategories?.length > 0 && menuItem?.entity !== "Event" && (
        <Select
          selectedValues={selectedCategoryIds.map((x) => String(x))}
          isMultiSelect={true}
          items={menuItems}
          label={
            translate("exclusiveCategoryFilter.label")?.replace(":", "") ?? ""
          }
          onChange={handleToggleCategory}
          suffixIcon={<ExpandIcon color={colors.neutral600} size={20} />}
        />
      )}
    </>
  );
};

export { ExclusiveCategoryFilter };
